/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { LinkButtonEditWrapper } from "./link-button-wrapper";
import { LinkButtonEditor } from "./link-button";
import { useNormalizedButtonList } from "./use-normalized-button-list";

const LinkButtonComponentEditor = () => {

    const { component, updateFactory } = useUpdateComponent();

    const buttonList = useNormalizedButtonList(component);

    const onChangeButtonList = updateFactory("button_list");

    return (
        <div className='simplicity-editor-frame'>
            <LinkButtonEditWrapper
                list={buttonList}
                onChange={onChangeButtonList}
            >
                <LinkButtonEditor/>
            </LinkButtonEditWrapper>
        </div>
    );
};

LinkButtonComponentEditor.displayName = "LinkButtonComponentEditor";
export { LinkButtonComponentEditor };
